var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoColoredWithName(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 666.5 170.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#150050;}.cls-2{fill:#5e85fe;}.cls-3{fill:#ef6051;}.cls-4{fill:#facf18;}.cls-5{fill:#fa9bfa;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M496.44,240.82c-15.56,0-27.3,12.07-27.3,28.08v5H454.93V291h14.21V354.6h21.34V291h16.24V273.92H490.48v-5c0-6.86,3.32-10.34,9.86-10.34a27.88,27.88,0,0,1,5.71.6l1.3.28V242l-.81-.21A43.34,43.34,0,0,0,496.44,240.82Z",
    transform: "translate(-227.56 -212.37)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M553.31,271.58c-24.37,0-42.76,18.38-42.76,42.76s18.39,42.6,42.76,42.6,42.92-18.32,42.92-42.6S577.78,271.58,553.31,271.58Zm21.26,42.76c0,14.49-8.54,24.23-21.26,24.23-12.52,0-21.26-10-21.26-24.23S540.79,290,553.31,290,574.57,300,574.57,314.34Z",
    transform: "translate(-227.56 -212.37)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M651.69,273c-14.29,0-24.7,10.81-26.25,21.4l2.81-20.46H608V354.6h21.34V317c0-15.2,7.35-23.92,20.17-23.92a29.35,29.35,0,0,1,7.87.91l1.32.31V274l-.85-.18A28.06,28.06,0,0,0,651.69,273Z",
    transform: "translate(-227.56 -212.37)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M873.36,273.92l2.42,11.62a17.77,17.77,0,0,0-2.31-3.09,28.44,28.44,0,0,0-2.33-2.18l-.11-.09c-.3-.25-.61-.49-.92-.73a37.33,37.33,0,0,0-5.15-3.22A39.52,39.52,0,0,0,847.23,272c-23,0-39,17.26-39,42,0,25,16,42.45,39,42.45,9.53,0,18.77-3.56,24.92-9.35a22.56,22.56,0,0,0,3.63-4.52l-2.81,12h21.09V273.92Zm-22.22,64.49c-12.61,0-21.42-10-21.42-24.39s8.61-23.92,21.42-23.92,21.57,9.62,21.57,23.92S863.84,338.41,851.14,338.41Z",
    transform: "translate(-227.56 -212.37)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M715.6,272.05",
    transform: "translate(-227.56 -212.37)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M692.55,273.92H671.44V354.6h21.34V311.53c0-14,5.77-21.74,16.26-21.74,9.79,0,15.17,6.5,15.17,18.3V354.6h21.34V311.53c0-14,5.56-21.74,15.65-21.74,9.28,0,14.39,6.5,14.39,18.3V354.6h21.34V305.44c0-20.29-11.52-33.39-29.33-33.39h-1.16a28.27,28.27,0,0,0-12.74,2.82,25.89,25.89,0,0,0-13.59,13.64c-4.8-11-12.72-16.36-24.13-16.47-14.29,0-24.69,11.73-26.25,22.32Z",
    transform: "translate(-227.56 -212.37)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M689.74,294.38",
    transform: "translate(-227.56 -212.37)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 53.81,
    cy: 22.29,
    r: 22.29
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 85.34,
    cy: 53.81,
    r: 22.29
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 116.86,
    cy: 22.29,
    r: 22.29
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 116.86,
    cy: 148.38,
    r: 22.29
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 85.34,
    cy: 116.86,
    r: 22.29
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 53.81,
    cy: 148.38,
    r: 22.29
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 148.38,
    cy: 53.81,
    r: 22.29
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 116.86,
    cy: 85.34,
    r: 22.29
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 148.38,
    cy: 116.86,
    r: 22.29
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 22.29,
    cy: 116.86,
    r: 22.29
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 53.81,
    cy: 85.34,
    r: 22.29
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 22.29,
    cy: 53.81,
    r: 22.29
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColoredWithName);
export default __webpack_public_path__ + "static/media/logo-colored-with-name.87b805c5284e3d16697e4723f6fb5613.svg";
export { ForwardRef as ReactComponent };